import React, { forwardRef, useEffect, useState } from "react";
import Label from "../../ui/Label";
import DateInput from "../../ui/DateInput";
import TimeInput from "../../ui/TimeInput";
import { ROUTES } from "../../utils/Routes";
import { useTabs } from "../../hooks/useTabs";
import Space from "../../ui/Space";
import { KBD } from "../../utils/Keybindings";
import { listen } from "../../hooks/Listener";
import { pubCall } from "../../utils/PubSub";
import { FILTER } from "../../utils/Struct";
import { showError } from "../../ui/Message";
import { bm_date, bm_time, updateOrdering } from "../../utils/Utils";
import Spin from "../../ui/Spin";
import dayjs from "dayjs";

const SalesIn = forwardRef(function ReportFilter(props, ref) {


    const { escape = () => { }, report = {}, height = 260, goto = () => { }, setReport = () => { }, where_type = "AND", edit = false, show_add = false, small = false, headerClass = "", showColumnHeaders = true, header = "",

        onFocus = () => { },
        onBlur = () => { },
        onClick = () => { },

        callback = () => {

        }

    } = props;

    const route = ROUTES.REPORTS.FILTER_SALES_IN;
    const [loading, setLoading] = useState(false)
    const [save, setSave] = useState(false);





    const onSave = (exit = false, _obj, _next = false) => {

        setLoading(true);
        let _filters = report.filters.filter(item => (item.type !== -6 && item.type !== -5) && item.where_type === "AND");


        const {
            date_from = getVal("date_from"),
            date_from_time = getVal("date_from_time"),
            date_to = getVal("date_to"),
            date_to_time = getVal("date_to_time"),
        } = _obj;

        let _date_from = bm_date(date_from, "YYYY-MM-DD");
        let _date_from_time = date_from_time;
        let _date_to = bm_date(date_to, "YYYY-MM-DD");
        let _date_to_time = date_to_time;


        if (_date_from || _date_to) {
            // add times
            if (_date_from && _date_from_time) {
                _date_from = _date_from + " " + _date_from_time + ":00";
            }
            if (_date_to && _date_to_time) {
                _date_to = _date_to + " " + _date_to_time + ":00";
            }
            _filters.unshift({ ...FILTER, "type": -5, "where_type": "AND", value_1: _date_from, value_2: _date_to })
        }

        _filters = updateOrdering(_filters);


        pubCall("report.purgeAndReplaceFilters", { report_id: report.report_id, filters_info: _filters, filter_where_type: "AND" }, (_s, _r) => {
            if (_s) {
                setReport(_r);
                if (exit) {
                    escape();
                    return;
                }
                if (_next) {
                    setTimeout(() => { next(); }, 1)
                }

            } else {
                showError(_r);
            }
            setLoading(false)
        })
    }


    const sales_period_between = report.filters?.find(item => item.type === -5);
    const _date_from = (sales_period_between?.value_1) ? sales_period_between?.value_1 : dayjs().add(-1, "day").format("YYYY-MM-DD");
    const _date_from_time = (sales_period_between?.value_1 && sales_period_between?.value_1.includes(" ")) ? dayjs(sales_period_between?.value_1).format("HH:mm") : "00:00";
    const _date_to = (sales_period_between?.value_2) ? sales_period_between?.value_2 : dayjs().format("YYYY-MM-DD");
    const _date_to_time = (sales_period_between?.value_2 && sales_period_between?.value_2.includes(" ")) ? dayjs(sales_period_between?.value_2).format("HH:mm") : "23:59";


    const defaultTabs = [

        { set: "scope", label: "date_from", key: "date_from", value: _date_from },
        { set: "scope", label: "date_from_time", key: "date_from_time", value: _date_from_time },
        { set: "scope", label: "date_to", key: "date_to", value: _date_to },
        { set: "scope", label: "date_to_time", key: "date_to_time", value: _date_to_time },

        // { label: "columns", key: "columns", value: "" },
    ]

    const {
        tabs, setTabs, index, setIndex, update, getVal, editProps, next, prev, refs
    } = useTabs(defaultTabs, "");



    useEffect(() => {
        if (edit) {
            window.bm_state.value = route;
            setIndex("date_from")
        } else {
            if (index !== "") {
                setIndex("")
            }
        }
    }, [edit])

    useEffect(() => {
        if (refs?.current[index]) refs.current[index].focus();

    }, [index, edit]);

    useEffect(() => {

        if (props.autoSave && props.autoSave === props.autoKey) {
            props.setAutoSave(false);
            onSave(true, tabs);
        }

        const actions = [
            { key: KBD.ESCAPE, action: () => escape() },
            { key: KBD.SHIFT_TAB, action: () => { if (index === "date_from") { goto("scope_type") } else { next(); } } },
            { key: KBD.TAB, action: () => { if (index === "date_to_time") { onSave(false, tabs); goto("sales_types") } else { next(); } } },
            { key: KBD.ENTER, action: () => { if (index === "date_to_time") { onSave(false, tabs); goto("sales_types") } else { next(); } } },
            { key: KBD.ARROW_DOWN, action: () => { if (index === "date_to_time") { onSave(false, tabs); goto("sales_types") } else { next(); } } },
            { key: KBD.ARROW_UP, action: () => { if (index === "date_from") { goto("scope_type") } else { prev(); } } },
            { key: KBD.PAGE_DOWN, action: () => onSave(true, tabs) },
        ];
        return listen(route, actions, () => { }, [
            KBD.TAB,
            KBD.SHIFT_TAB,
            KBD.ENTER,
            KBD.PAGE_DOWN,
            KBD.ARROW_DOWN,
            KBD.ARROW_UP,
            KBD.ESCAPE
        ]);
    }, [index, tabs, props.autoSave]);

    return (
        <div className="no-focus" onBlur={() => onBlur()} onFocus={() => onFocus()} onClick={() => onFocus()} ref={ref} tabIndex={0}>

            <Space>
                <Label >Date</Label>
                <div>
                    <DateInput show_preset={true} cycle={["yesterday", "today"]} route={route} shrink={false} width={95} {...editProps("date_from")} onPreFilled={(e) => onSave(false, { ...tabs, "date_from": e }, false)} onFilled={(e) => onSave(false, { ...tabs, "date_from": e }, true)} onClick={() => (index !== "date_from") && setIndex("date_from")} onBlur={(e) => { update("date_from", e) }} edit={edit} />
                </div>
                <div>
                    <TimeInput show_preset={true} route={route} shrink={false} width={70} {...editProps("date_from_time")} onPreFilled={(e) => onSave(false, { ...tabs, "date_from_time": e }, false)} onFilled={(e) => onSave(false, { ...tabs, "date_from_time": e }, true)} onEnter={() => next()} onClick={() => (index !== "date_from_time") && setIndex("date_from_time")} edit={edit} />
                </div>
                <Label>to</Label>
                <div>
                    <DateInput show_preset={true} cycle={["today", "yesterday"]} route={route} shrink={false} width={95} {...editProps("date_to")} onPreFilled={(e) => onSave(false, { ...tabs, "date_to": e }, false)} onFilled={(e) => onSave(false, { ...tabs, "date_to": e }, true)} onClick={() => (index !== "date_to") && setIndex("date_to")} onBlur={(e) => { update("date_to", e) }} edit={edit} />
                </div>
                <div>
                    <TimeInput show_preset={true} cycle={["23:59", "00:00", "now"]} route={route} shrink={false} width={70} {...editProps("date_to_time")} onPreFilled={(e) => onSave(false, { ...tabs, "date_to_time": e }, false)} onFilled={(e) => onSave(true, { ...tabs, "date_to_time": e })} onEnter={(e) => onSave(true, { ...tabs, "date_to_time": e })} onClick={() => (index !== "date_to_time") && setIndex("date_to_time")} edit={edit} />
                </div>
            </Space>
        </div>
    )
});

export default SalesIn;